import * as React from 'react';
import { useState } from 'react';

import { Drawer } from '@coursera/cds-core';

import CodeBlockNameContent from 'bundles/cml/editor/components/elements/code/dialogs/CodeBlockNameContent';
import type { CodeElement } from 'bundles/cml/shared/types/elementTypes';

import _t from 'i18n!nls/cml';

type Props = {
  element: CodeElement;
  onClose: () => void;
};

const DRAWER_TRANSITION_DURATION = 200;

const CodeBlockNameDrawer = ({ element, onClose }: Props) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    setTimeout(onClose, DRAWER_TRANSITION_DURATION);
  };

  return (
    <Drawer open={open} aria-label={_t('Edit code block name')} onClose={handleClose}>
      <CodeBlockNameContent element={element} onClose={handleClose} />
    </Drawer>
  );
};

export default CodeBlockNameDrawer;
